import template from './cvcInfo.html';
import './cvcInfo.scss';

export const CvcInfo = angular
    .module('checkout.components.cvcInfo', [
        'ngMaterial'
    ]).component('cvcInfo', {
        template: `
            <button class="cvc-info" ng-click="$ctrl.showInfoModal($event)" tabindex="-1">
                <md-icon>info</md-icon>
            </button>
        `,
        controller: class CvcInfoCtrl {
            constructor($mdDialog, $window) {
                this.$mdDialog = $mdDialog;
                this.$window = $window;
            }

            showInfoModal($event) {
                this.$mdDialog.show({
                    controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
                        const vm = {
                            close
                        };
                        init();

                        function init() {
                            $scope.vm = vm;
                        }

                        function close() {
                            $mdDialog.hide();
                        }
                    }],
                    template,
                    parent: angular.element(this.$window.document.body),
                    targetEvent: $event,
                    clickOutsideToClose: true,
                    multiple: true
                });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/creditCardForm/cvcInfo/cvcInfo.js